export default __webpack_public_path__ + "static/media/brigitta-parnigoni.ad7e17ab.jpg";